import {ValidationErrorKeys} from '@hconnect/common/consts'
import {type TFunction} from 'i18next'
import {object, string} from 'yup'

import {YesNoFormValue} from '../../types'

export const TEXT_MAX_LENGTH = 256
export const COMMENT_MAX_LENGTH = 512

export const getYesNoWithCommentSchema = ({t}: {t: TFunction}) =>
  object().shape({
    value: string()
      .oneOf([YesNoFormValue.YES, YesNoFormValue.NO])
      .required(t(ValidationErrorKeys.REQUIRED)),
    comment: string().when(['value'], {
      is: (value: YesNoFormValue) => value === YesNoFormValue.NO,
      then: string()
        .required(t(ValidationErrorKeys.REQUIRED))
        .max(COMMENT_MAX_LENGTH, t(ValidationErrorKeys.MAX_LENGTH, {max: COMMENT_MAX_LENGTH})),
      otherwise: string()
    })
  })
